module.exports = __webpack_public_path__ + "img/page.d7cdde1b.png";